<template>
  <div>
    <vxe-grid
      ref="grid"
      v-bind="xGridOptions"
      highlight-hover-row
      show-overflow="title"
      border
      resizable
      height="545"
      :row-class-name="tableRowClassName"
      @form-submit="onSubmitQuery"
      @form-reset="onReset"
      @cell-click="cellClick"
      :loading="loading"
      :radio-config="{trigger:'row'}"
      :seq-config="{startIndex: (xGridOptions.pagerConfig.currentPage - 1) * xGridOptions.pagerConfig.pageSize}"
      :pager-config="xGridOptions.pagerConfig"
      @page-change="handlePageChange"
    ></vxe-grid>
  </div>
</template>

<script>
import { UnitmanageApi } from "api/base.js";
import FormGridPWindow from "components/grid/FormGridPWindow.vue";

export default {
  components: {
    FormGridPWindow
  },
  props: {
    tableColumns: {
      Type: Array
    }
  },
  data() {
    return {
      loading: false,
      // tablePage: {
      //   total: 0,//总条数
      //   currentPage: 1,//当前页
      //   pageSize: 10,//每页大小
      //   align: "left",
      //   pageSizes: [10, 20, 50, 100],//每页大小选项列表
      //   layouts: [//自定义布局
      //     "Sizes",
      //     "PrevJump",
      //     "PrevPage",
      //     "Number",
      //     "NextPage",
      //     "NextJump",
      //     "FullJump",
      //     "Total"
      //   ],
      //   perfect: true
      // },
      fromData: {
        page: 1, //当前页
        pageSize: 10 //总数量,
      },
      EditData: {
        materialDto: {}
      },
      xGridOptions: {
        resizable: true, //列是否允许拖动列宽调整大小
        height: "100%",
        //分页信息
        pagerConfig: {
          total: 0, //总条数
          currentPage: 1, //当前页
          pageSize: 10, //每页大小
          align: "left",
          pageSizes: [10, 20, 50, 100], //每页大小选项列表
          layouts: [
            //自定义布局
            "Sizes",
            "PrevJump",
            "PrevPage",
            "Number",
            "NextPage",
            "NextJump",
            "FullJump",
            "Total"
          ],
          perfect: true
        },
        toolbar: {
          // buttons: [
          // { code: 'insert_actived', name: 'Add', icon: 'fa fa-plus' },
          // { code: 'mark_cancel', name: '删除/取消', icon: 'fa fa-bookmark-o' },
          // { code: 'save', name: 'Save', icon: 'fa fa-save' }
          // ],
          import: true,
          perfect: true,
          refresh: true,
          custom: true,
          export: true,
          zoom: true
        },
        data: [],
        exportConfig: {},
        importConfig: {
          remote: true,
          types: ["xlsx"],
          modes: ["insert"]
        },
        formConfig: {
          titleWidth: 100,
          titleAlign: "right",
          items: [
            {
              field: "unitCode",
              title: "单位编码:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入单位编码" }
              }
            },
            {
              field: "unitDesc",
              title: "单位描述:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入单位描述" }
              }
            },
            {
              field: "companyName",
              title: "公司描述:",
              span: 6,
              itemRender: {
                name: "input",
                attrs: { placeholder: "请输入公司描述" }
              }
            },
            {
              span: 6,
              align: "right",
              collapseNode: true,
              itemRender: {
                name: "$buttons",
                children: [
                  {
                    props: {
                      type: "submit",
                      content: "查询",
                      status: "primary"
                    }
                  },
                  {
                    props: {
                      type: "reset",
                      content: "重置"
                    }
                  }
                ]
              }
            },
            {
              span: 6,
              folding: true
            },
            
            //FormItemButtonGroup
          ],
          data: {}
        },
        columns: this.tableColumns
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
        if (row.maintainStatus == "X") {
          return 'warning-row';
        }
        return '';
    },
    //编辑时需要用到的
    onEditUnit() {
      let radioData = this.$refs.grid.getRadioRecord();
      if (radioData) {
        // console.log(radioData.tenantId)
        this.$emit("EdUnitId", radioData.unitId);
      } else {
        this.$emit("EdUnitId", null);
      }
    },
     //删除时需要用到的
    onDelUnit() {
      let radioData = this.$refs.grid.getRadioRecord();
      if (radioData) {
        console.log(radioData)
        this.$emit("DelUnit", radioData);
      } else {
        this.$emit("DelUnit", null);
      }
    },
    //恢复删除时需要用到的
    onRestoreUnit() {
      let radioData = this.$refs.grid.getRadioRecord();
      if (radioData) {
        console.log(radioData)
        this.$emit("RestoreUnit", radioData);
      } else {
        this.$emit("RestoreUnit", null);
      }
    },
    //分页
    searchEvent() {
      this.xGridOptions.pagerConfig.currentPage = 1;
      this.getList();
    },
    handlePageChange({ currentPage, pageSize }) {
      console.log(currentPage, pageSize);
      this.xGridOptions.pagerConfig.currentPage = currentPage;
      this.xGridOptions.pagerConfig.pageSize = pageSize;
      this.getList();
    },
    //查询
    onSubmitQuery() {
      console.log(this.xGridOptions.formConfig.data);
      this.fromData.searchCriteria = this.xGridOptions.formConfig.data;
      console.log(this.fromData);
      this.getList();
    },
    //重置
    onReset() {
      this.xGridOptions.formConfig.data = {};
    },
    // query:{

    // },
    //获取列表
    async getList() {
      this.loading = true;
      let res = await this.$post(UnitmanageApi.list, {
        page: this.xGridOptions.pagerConfig.currentPage,
        pageSize: this.xGridOptions.pagerConfig.pageSize
      });
      console.log(res);
      if (res.status && res.data) {
        this.xGridOptions.data = res.data.list;

        this.xGridOptions.pagerConfig.total = res.data.total;
        this.loading = false;
        // this.pages = res.data.pages;
        // this.total = res.data.total;
      } else {
        this.xGridOptions.data = [];
        this.loading = false;
        // this.pages = 0;
        // this.total = 0;
      }
    },
    cellClick(data){
        console.log(data.row)
        this.$emit("cellClick", data.row);
    }
  }
};
</script>

<style>
.vxe-grid .warning-row {
    background: oldlace;
  }
</style>
